module.exports = __webpack_public_path__ + "img/zhiMa.c5fa5c36.png";